import React from 'react';
import { FormattedMessage } from 'react-intl';

import './alertMessage.scss';

export default function AlertMessage({ id, defaultMessage }) {
  return (
    <div className="message--alert">
      <FormattedMessage id={id} defaultMessage={defaultMessage} />
    </div>
  );
}
